import { IGetFuncionarioParaAprovacaoDropDownUseCase } from "../../../presentation/useCases/read/get_funcionario_para_aprovacao_drop_down_use_case";
import { FuncionarioAprovacaoDropDown } from "../../models/funcionario_aprovacao";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFuncionarioParaAprovacaoDropDownUseCase
 */

export class GetFuncionarioParaAprovacaoDropDownUseCase implements IGetFuncionarioParaAprovacaoDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFuncionarioParaAprovacaoDropDown(): Promise<FuncionarioAprovacaoDropDown[]> {
    return await this.repository.getFuncionarioParaAprovacaoDropDown();
  }
}
